<template>
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 8.5V6.5C17.5 5.39543 16.6046 4.5 15.5 4.5H5.5C4.39543 4.5 3.5 5.39543 3.5 6.5V8.5M17.5 8.5V15.5C17.5 16.6046 16.6046 17.5 15.5 17.5H5.5C4.39543 17.5 3.5 16.6046 3.5 15.5V8.5M17.5 8.5H3.5M10.5 11.5V14.5M8.5 13.5H12.5"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      fill="none"
    />
    <circle class="fill" cx="10.5" cy="6.5" r="1" fill="currentColor" />
  </svg>
</template>

<script lang="ts">
export default { name: "AdminIcon" };
</script>

<style scoped lang="scss">
@use "./icon.scss";
</style>
